module.exports = __webpack_public_path__ + "img/Welding_Ring_Set.16ef96b6.webp";